import { Injectable, EventEmitter } from "@angular/core";
import gql from "graphql-tag";

import { Apollo } from "apollo-angular";

@Injectable()
export class UsRegisterHospitalsService {
  constructor(private apollo: Apollo) {}

  getTable2Data(searchOpts) {
    /* parameters:
        tableId=us-reg
        sYear
        */
    const query = gql`
      query GetTable2Data($tableId: String, $sYear: String){
        getTable2Data(tableId: $tableId, sYear: $sYear){
          tableTitle
          tableDetails
          download{
            pdf
            excel
          }
          data{
            headers {
              label
              heading
            }
            section{
              label
              row{
                cell{
                  label
                  heading
                  value
                }
              }
              subsection{
                label
                row{
                  cell{
                    label
                    value
                    heading
                  }
                }
                subsection{
                  label
                  row{
                    cell{
                      label
                      value
                      heading
                    }
                  }
                }
              }
            }
          }
        }
      }      
    `;

    return this.apollo.watchQuery<any>({
      query: query,
      variables: searchOpts
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/t2-us-register-hospitals/us-register-hospitals.services.ts